module.exports = __webpack_public_path__ + "public/img/18.0325aca2.png";